import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

import { getAgentPermsApi, getEnterprisePermsApi } from 'chat/api/perm';

const initState = Map({
  enterprisePerms: {},
  agentPerms: {},
  mePerms: []
});

export const { getAgentPerms, getEnterprisePerms } = createActions({
  GET_AGENT_PERMS: async () => {
    const result = await getAgentPermsApi();
    return result;
  },
  GET_ENTERPRISE_PERMS: async () => {
    const result = await getEnterprisePermsApi();
    return result;
  }
});

const perm = handleActions(
  {
    [getAgentPerms]: (state, action) => {
      if (action.payload && action.payload.data) {
        const perms = action.payload.data.perms || {};
        const mePerms = [];
        Object.keys(perms).forEach(key => {
          const permsList = perms[key];
          permsList.forEach(item => {
            mePerms.push(item.key);
          });
        });
        return state.set('agentPerms', action.payload.data).set('mePerms', mePerms);
      }
      return state;
    },
    [getEnterprisePerms]: (state, action) => {
      return state.set('enterprisePerms', action.payload.data);
    }
  },
  initState
);

export default perm;
